import React, {useState} from "react";
import {useTheme, IconButton, Menu, MenuItem, ListItemIcon, ListItemText, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CustomChipComponent from "../../../../core/components/common/custom-chip.component";
import UpdateIcon from "@mui/icons-material/Update";
import {useNavigate} from "react-router-dom";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import UpdateStatusDialog from "./update-status.dialog";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import DeleteGatePassConfigurationDialog from "./delete-gatepass-configuration.dialog";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import EditGatePassConfigurationDialog from "./edit-gatepass-configuration.dialog";


const CustomMenuPopperComponent = (props) => {
    const {data, setSelectedProfile, theme, customIconStyles, setOpenUpdateStatus, setOpenDeleteGatePass, setOpenEditGatePass} = props;

    const navigate = useNavigate();

    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
        
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    }
        
    const handleClose = () => {
        setAnchorEl(null);
    }

    const handleViewDetails = (e, data) => {
        navigate("/rbac/gatepass-configuration/view?role=" + data?.role + "&id=" + data?.profile_gatepass_type_uid);
    }
    
    const handleUpdateStatus = (e, data) => {
        setSelectedProfile(data);
        setOpenUpdateStatus(true);
    }

    const handleDeleteGatePass = (e, data) => {
        setSelectedProfile(data);
        setOpenDeleteGatePass(true);
    }

    const handleEditGatePass = (e, data) => {
        setSelectedProfile(data);
        setOpenEditGatePass(true);
    }


    const menuItems = [
        {
            icon: <VisibilityIcon fontSize="small" sx={{color: theme.palette.primary.main}} />,
            label: "View Details",
            onClick: (e) => handleViewDetails(e, data),
            
        },
        {
            icon: <BorderColorIcon fontSize="small" sx={{color: theme.palette.primary.main}} />,
            label: "Edit Gate Pass",
            onClick: (e) => handleEditGatePass(e, data),
        },
        {
            icon: <UpdateIcon fontSize="small" sx={{color: theme.palette.primary.main, fontSize: 23}} />,
            label: "Update Status",
            onClick: (e) => handleUpdateStatus(e, data),
        },
        {
            icon: <DeleteForeverIcon fontSize="small" sx={{color: "#f01818", fontSize: 23}} />,
            label: "Delete Gate Pass",
            onClick: (e) => handleDeleteGatePass(e, data),
        }
    ]


    return (
        <>
            <IconButton onClick={handleClick}>
                <MoreVertIcon />
            </IconButton>
  
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                PaperProps={{style: {maxHeight: 300}}}
            >
                {menuItems?.map((item, index) => (
                    <MenuItem
                        key={index}
                        onClick={() => {
                            handleClose();
                            item.onClick();
                        }}
                        sx={{}}
                    >
                        <ListItemIcon sx={customIconStyles}>
                            {item.icon}
                        </ListItemIcon>
            
                        <ListItemText sx={{ml: "-3px"}} primary={item.label} />
                    </MenuItem>
                ))}
            </Menu>
        </>
    )
}

const ListGatePassConfigurationComponent = (props) => {
    const {headers, data} = props;

    const theme = useTheme();

    const [openUpdateStatus, setOpenUpdateStatus] = useState(false);
    const [selectedProfile, setSelectedProfile] = useState(null);
    const [openDeleteGatePass, setOpenDeleteGatePass] = useState(false);
    const [openEditGatePass, setOpenEditGatePass] = useState(false);


    return (
        <Paper elevation={0} sx={{width: "100%", overflow: "hidden", border: "1px solid #e5edf6", boxShadow: "none", borderRadius: 1}}>
            <TableContainer>
                <Table>
                    <TableHead sx={{backgroundColor: "inherit", color: "inherit"}}>
                        <TableRow>
                            {headers.map((header, index) => (
                                <TableCell
                                    key={index}
                                    align="start"
                                    sx={{color: theme.typography.secondary, fontWeight: 600}}
                                >
                                    {header}
                                </TableCell>
                            ))}                   
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {data?.length > 0 ? (
                            data?.map((gatepass_config) => (
                                <TableRow key={gatepass_config?.id}>
                                    <TableCell component="th" scope="row" sx={{color: theme.typography.primary, fontWeight: 600}}>
                                        {gatepass_config?.entry_type}
                                    </TableCell>

                                    <TableCell component="th" scope="row">
                                        <CustomChipComponent category="gatePassType"
                                            label={(gatepass_config?.gatepass_type === "Single Entry Pass") ? "Single Entry" 
                                                : 
                                                    (gatepass_config?.gatepass_type === "Multi Entry Pass") ? "Multi Entry"
                                                :
                                                    (gatepass_config?.gatepass_type === "Annual Pass") ? "Annual"
                                                :
                                                    (gatepass_config?.gatepass_type === "Special Entry Pass") ? "Special Entry"
                                                :
                                                    gatepass_config?.gatepass_type
                                            }
                                        />
                                    </TableCell>

                                    <TableCell component="th" scope="row">
                                        <CustomChipComponent category="gatePassStatus"
                                            label={(gatepass_config?.status === "Active") ? "Active" 
                                                : 
                                                    (gatepass_config?.status === "Inactive") ? "Inactive"
                                                :
                                                    gatepass_config?.status
                                            }
                                       />
                                    </TableCell>

                                    <TableCell align="start">
                                        <CustomMenuPopperComponent 
                                            data={gatepass_config} 
                                            setOpenUpdateStatus={setOpenUpdateStatus}
                                            setOpenDeleteGatePass={setOpenDeleteGatePass}
                                            setOpenEditGatePass={setOpenEditGatePass}
                                            setSelectedProfile={setSelectedProfile}
                                            theme={theme}
                                        />
                                    </TableCell>
                                </TableRow>
                            ))
                        ) : (
                            <TableRow>
                                <TableCell colSpan={headers?.length} align="center">
                                    No gatepass configuration data available to display
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>

            {openUpdateStatus && 
                <UpdateStatusDialog 
                    open={openUpdateStatus} 
                    setOpen={setOpenUpdateStatus} 
                    selectedProfile={selectedProfile}
                />
            }

            {openDeleteGatePass && 
                <DeleteGatePassConfigurationDialog 
                    open={openDeleteGatePass} 
                    setOpen={setOpenDeleteGatePass} 
                    selectedProfile={selectedProfile}
                />
            }

            {openEditGatePass && 
                <EditGatePassConfigurationDialog
                    open={openEditGatePass} 
                    setOpen={setOpenEditGatePass} 
                    selectedProfile={selectedProfile}
                />
            }  
        </Paper>
    )
}

export default ListGatePassConfigurationComponent